module.exports = __webpack_public_path__ + "img/OurPractice1.813169b9.png";